import styled from 'styled-components'

export const TableSentRecurrences = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        /* border-top: 1px solid #d3d3d3; */

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        th:last-child {
            /* width: 40px; */
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 12px;
            /* width: max-content; */
        }

        td:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }
`

export const TableReceivedRecurrences = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        /* border-top: 1px solid #d3d3d3; */

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        th:last-child {
            /* width: 40px; */
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 12px;
            /* width: max-content; */
        }

        td:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }
`
